module.exports = __webpack_public_path__ + "media/images/person_lerge-2931ab654e55b67246abe73f5a8557a7.svg";